import Vue from "vue";
import VueRouter from "vue-router";
// import cookies from "@/plugins/cookie";
import { clearPending } from "@/utils/request";
import Login from "@/views/login/index.vue";
import Admin from "@/views/admin/index.vue";

// 平台统计
const StatisticsManage = () =>
  import("@/views/admin/statistics_manage/index.vue");

// 数据管理
const DataManage = () => import("@/views/admin/data_manage/index.vue");
const AchievementList = () =>
  import("@/views/admin/data_manage/achievement/list.vue");
const AchievementInfo = () =>
  import("@/views/admin/data_manage/achievement/info.vue");
const DemandList = () => import("@/views/admin/data_manage/demand/list.vue");
const DemandInfo = () => import("@/views/admin/data_manage/demand/info.vue");
const PatentList = () => import("@/views/admin/data_manage/patent/list.vue");
const PatentInfo = () => import("@/views/admin/data_manage/patent/info.vue");
const TypicalCaseList = () =>
  import("@/views/admin/data_manage/typical_case/list.vue");
const TypicalCaseInfo = () =>
  import("@/views/admin/data_manage/typical_case/info.vue");

// 推荐管理
const RecommendManage = () =>
  import("@/views/admin/recommend_manage/index.vue");
const KeywordRecommend = () =>
  import("@/views/admin/recommend_manage/list/keyword.vue");
const HomepageRecommend = () =>
  import("@/views/admin/recommend_manage/list/homepage.vue");
const RecommendDem = () =>
  import("@/views/admin/recommend_manage/choice/demand.vue");
const RecommendAch = () =>
  import("@/views/admin/recommend_manage/choice/achievement.vue");
const RecommendAct = () =>
  import("@/views/admin/recommend_manage/choice/activity.vue");
const RecommendPolicy = () =>
  import("@/views/admin/recommend_manage/choice/policy.vue");
const RecommendPatent = () =>
  import("@/views/admin/recommend_manage/choice/patent.vue");
const RecommendNews = () =>
  import("@/views/admin/recommend_manage/choice/news.vue");

// 对接管理
const DockingManage = () => import("@/views/admin/docking_manage/index.vue");
const AchDockingList = () =>
  import("@/views/admin/docking_manage/achievement/list.vue");
const AchDockingInfo = () =>
  import("@/views/admin/docking_manage/achievement/info.vue");
const DemDockingList = () =>
  import("@/views/admin/docking_manage/demand/list.vue");
const DemDockingInfo = () =>
  import("@/views/admin/docking_manage/demand/info.vue");
const PatDockingList = () =>
  import("@/views/admin/docking_manage/patent/list.vue");

// 解决方案
const SolutionManage = () => import("@/views/admin/solution_manage/index.vue");
const SolutionCaseList = () =>
  import("@/views/admin/solution_manage/case/list.vue");

// 服务管理
const ServiceManage = () => import("@/views/admin/service_manage/index.vue");
const PatServiceList = () =>
  import("@/views/admin/service_manage/patent/list.vue");
const FinanceServiceList = () =>
  import("@/views/admin/service_manage/finance/list.vue");
const StandardServiceList = () =>
  import("@/views/admin/service_manage/standard/list.vue");
const QualificationApplyList = () =>
  import("@/views/admin/service_manage/qualification/apply.vue");
const QualificationEvaluateList = () =>
  import("@/views/admin/service_manage/qualification/evaluate/list.vue");
const QualificationEvaluateInfo = () =>
  import("@/views/admin/service_manage/qualification/evaluate/info.vue");
const QualificationEvaluateScore = () =>
  import("@/views/admin/service_manage/qualification/evaluate/score.vue");
const ServiceCaseList = () =>
  import("@/views/admin/service_manage/case/list.vue");
const ServiceCaseInfo = () =>
  import("@/views/admin/service_manage/case/info.vue");

// 专家管理
const ExpertManage = () => import("@/views/admin/expert_manage/index.vue");
const ExpertMessageList = () =>
  import("@/views/admin/expert_manage/expert_message/list.vue");
const ExpertServiceApplyList = () =>
  import("@/views/admin/expert_manage/service_apply/list.vue");
const ExpertServiceMessageList = () =>
  import("@/views/admin/expert_manage/service_message/list.vue");

// 政策之窗
const PolicyManage = () => import("@/views/admin/policy_manage/index.vue");
const PolicyMessageList = () =>
  import("@/views/admin/policy_manage/policy_message/list.vue");
const PolicyMessageAudit = () =>
  import("@/views/admin/policy_manage/policy_message/audit.vue");
const PolicyMessageInfo = () =>
  import("@/views/admin/policy_manage/policy_message/info.vue");
const PolicyExplainList = () =>
  import("@/views/admin/policy_manage/policy_explain/list.vue");
const PolicyExplainAudit = () =>
  import("@/views/admin/policy_manage/policy_explain/audit.vue");
const PolicyExplainInfo = () =>
  import("@/views/admin/policy_manage/policy_explain/info.vue");
const ProjectMessageList = () =>
  import("@/views/admin/policy_manage/project_message/list.vue");
const ProjectMessageInfo = () =>
  import("@/views/admin/policy_manage/project_message/info.vue");
const ProjectDeclareList = () =>
  import("@/views/admin/policy_manage/project_declare/list.vue");
const ProjectPublicityList = () =>
  import("@/views/admin/policy_manage/project_publicity/list.vue");

// 加工资源填报管理
const MachiningManage = () =>
  import("@/views/admin/machining_manage/index.vue");
const MachiningComponentList = () =>
  import("@/views/admin/machining_manage/component/list.vue");
const MachiningComponentInfo = () =>
  import("@/views/admin/machining_manage/component/info.vue");
const MachiningRobotList = () =>
  import("@/views/admin/machining_manage/robot/list.vue");
const MachiningRobotInfo = () =>
  import("@/views/admin/machining_manage/robot/info.vue");
// 活动管理
const ActivityManage = () => import("@/views/admin/activity_manage/index.vue");
const ActivityMessageList = () =>
  import("@/views/admin/activity_manage/activity_message/list.vue");
const ActivityMessageInfo = () =>
  import("@/views/admin/activity_manage/activity_message/info.vue");
const ActivityMessageApply = () =>
  import("@/views/admin/activity_manage/activity_message/apply.vue");
const ActivityCompanyList = () =>
  import("@/views/admin/activity_manage/activity_company/list.vue");
const ActivityApplyList = () =>
  import("@/views/admin/activity_manage/activity_apply/list.vue");
const NewsList = () => import("@/views/admin/activity_manage/news/list.vue");
const NewsInfo = () => import("@/views/admin/activity_manage/news/info.vue");

// 专题赛管理
const CompetitionManage = () =>
  import("@/views/admin/competition_manage/index.vue");
const ContestApplyList = () =>
  import("@/views/admin/competition_manage/contest_apply/list.vue");
const ContestNoticeList = () =>
  import("@/views/admin/competition_manage/contest_notice/list.vue");
const ContestNoticeInfo = () =>
  import("@/views/admin/competition_manage/contest_notice/info.vue");
const ContestActivityList = () =>
  import("@/views/admin/competition_manage/contest_activity/list.vue");
const ContestActivityInfo = () =>
  import("@/views/admin/competition_manage/contest_activity/info.vue");
const ContestDemList = () =>
  import("@/views/admin/competition_manage/contest_demand/list.vue");
const ContestDemInfo = () =>
  import("@/views/admin/competition_manage/contest_demand/info.vue");
const ContestSolutionList = () =>
  import("@/views/admin/competition_manage/contest_solution/list.vue");
const ContestSolutionInfo = () =>
  import("@/views/admin/competition_manage/contest_solution/info.vue");
const ContestServiceList = () =>
  import("@/views/admin/competition_manage/contest_service/list.vue");

// 用户管理
const UserManage = () => import("@/views/admin/user_manage/index.vue");
const UserContentlist = () =>
  import("@/views/admin/user_manage/user_content/list.vue");
const UserContentInfo = () =>
  import("@/views/admin/user_manage/user_content/info.vue");
const UserComCerInfo = () =>
  import("@/views/admin/user_manage/user_content/com_cer.vue");
const UserPerCerInfo = () =>
  import("@/views/admin/user_manage/user_content/per_cer.vue");
const UserCertifiedist = () =>
  import("@/views/admin/user_manage/user_certified/list.vue");

// 系统管理
const SystemManage = () => import("@/views/admin/system_manage/index.vue");
const NotificationList = () =>
  import("@/views/admin/system_manage/notification/list.vue");
const NotificationInfo = () =>
  import("@/views/admin/system_manage/notification/info.vue");

// 权限管理
const PrivilegeManage = () =>
  import("@/views/admin/privilege_manage/index.vue");
const DepartmentList = () =>
  import("@/views/admin/privilege_manage/department/list.vue");
const RoleList = () => import("@/views/admin/privilege_manage/role/list.vue");
const RoleInfo = () => import("@/views/admin/privilege_manage/role/info.vue");
const AccountList = () =>
  import("@/views/admin/privilege_manage/account/list.vue");
const AccountInfo = () =>
  import("@/views/admin/privilege_manage/account/info.vue");

const NotFound = () => import("@/views/errorPage/404.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Login
  },
  {
    path: "/admin",
    component: Admin,
    // beforeEnter: (to, from, next) => {
    //   const hasToken = cookies.get("backToken");
    //   if (hasToken) {
    //     next();
    //   } else {
    //     next({ path: "/" });
    //   }
    // },
    children: [
      {
        path: ""
      },
      {
        path: "statisticsManage",
        component: StatisticsManage
      },
      {
        path: "dataManage",
        component: DataManage,
        children: [
          {
            path: "",
            redirect: "achievementList"
          },
          {
            path: "achievementList",
            component: AchievementList
          },
          {
            path: "achievementInfo/:method",
            component: AchievementInfo
          },
          {
            path: "demandList",
            component: DemandList
          },
          {
            path: "demandInfo/:method",
            component: DemandInfo
          },
          {
            path: "patentList",
            component: PatentList
          },
          {
            path: "patentInfo/:method",
            component: PatentInfo
          },
          {
            path: "typicalCaseList",
            component: TypicalCaseList
          },
          {
            path: "typicalCaseInfo/:method",
            component: TypicalCaseInfo
          }
        ]
      },
      {
        path: "recommendManage",
        component: RecommendManage,
        children: [
          {
            path: "",
            redirect: "keywordRecommend"
          },
          {
            path: "keywordRecommend",
            component: KeywordRecommend
          },
          {
            path: "homepageRecommend",
            component: HomepageRecommend
          },
          {
            path: "recommendDem",
            component: RecommendDem
          },
          {
            path: "recommendAch",
            component: RecommendAch
          },
          {
            path: "recommendAct",
            component: RecommendAct
          },
          {
            path: "recommendPolicy",
            component: RecommendPolicy
          },
          {
            path: "recommendPatent",
            component: RecommendPatent
          },
          {
            path: "recommendNews",
            component: RecommendNews
          }
        ]
      },
      {
        path: "dockingManage",
        component: DockingManage,
        children: [
          {
            path: "",
            redirect: "achDockingList"
          },
          {
            path: "achDockingList",
            component: AchDockingList
          },
          {
            path: "achDockingInfo",
            component: AchDockingInfo
          },
          {
            path: "demDockingList",
            component: DemDockingList
          },
          {
            path: "demDockingInfo",
            component: DemDockingInfo
          },
          {
            path: "patDockingList",
            component: PatDockingList
          }
        ]
      },
      {
        path: "solutionManage",
        component: SolutionManage,
        children: [
          {
            path: "",
            redirect: "solutionCaseList"
          },
          {
            path: "solutionCaseList",
            component: SolutionCaseList
          }
        ]
      },
      {
        path: "serviceManage",
        component: ServiceManage,
        children: [
          {
            path: "",
            redirect: "patServiceList"
          },
          {
            path: "patServiceList",
            component: PatServiceList
          },
          {
            path: "financeServiceList",
            component: FinanceServiceList
          },
          {
            path: "standardServiceList",
            component: StandardServiceList
          },
          {
            path: "qualificationApplyList",
            component: QualificationApplyList
          },
          {
            path: "qualificationEvaluateList",
            component: QualificationEvaluateList
          },
          {
            path: "qualificationEvaluateInfo",
            component: QualificationEvaluateInfo
          },
          {
            path: "qualificationEvaluateScore",
            component: QualificationEvaluateScore
          },
          {
            path: "serviceCaseList",
            component: ServiceCaseList
          },
          {
            path: "serviceCaseInfo/:method",
            component: ServiceCaseInfo
          }
        ]
      },
      {
        path: "expertManage",
        component: ExpertManage,
        children: [
          {
            path: "",
            redirect: "expertMessageList"
          },
          {
            path: "expertMessageList",
            component: ExpertMessageList
          },
          {
            path: "expertServiceApplyList",
            component: ExpertServiceApplyList
          },
          {
            path: "expertServiceMessageList",
            component: ExpertServiceMessageList
          }
        ]
      },
      {
        path: "policyManage",
        component: PolicyManage,
        children: [
          {
            path: "",
            redirect: "policyMessageList"
          },
          {
            path: "policyMessageList",
            component: PolicyMessageList
          },
          {
            path: "policyMessageAudit",
            component: PolicyMessageAudit
          },
          {
            path: "policyMessageInfo/:method",
            component: PolicyMessageInfo
          },
          {
            path: "policyExplainList",
            component: PolicyExplainList
          },
          {
            path: "policyExplainAudit",
            component: PolicyExplainAudit
          },
          {
            path: "policyExplainInfo/:method",
            component: PolicyExplainInfo
          },
          {
            path: "projectMessageList",
            component: ProjectMessageList
          },
          {
            path: "projectMessageInfo/:method",
            component: ProjectMessageInfo
          },
          {
            path: "projectDeclareList",
            component: ProjectDeclareList
          },
          {
            path: "projectPublicityList",
            component: ProjectPublicityList
          }
        ]
      },
      {
        path: "machiningManage",
        component: MachiningManage,
        children: [
          {
            path: "",
            redirect: "machiningComponentList"
          },
          {
            path: "machiningComponentList",
            component: MachiningComponentList
          },
          {
            path: "machiningComponentInfo/:method",
            component: MachiningComponentInfo
          },
          {
            path: "machiningRobotList",
            component: MachiningRobotList
          },
          {
            path: "machiningRobotInfo/:method",
            component: MachiningRobotInfo
          }
        ]
      },
      {
        path: "activityManage",
        component: ActivityManage,
        children: [
          {
            path: "",
            redirect: "activityMessageList"
          },
          {
            path: "activityMessageList",
            component: ActivityMessageList
          },
          {
            path: "activityMessageInfo/:method",
            component: ActivityMessageInfo
          },
          {
            path: "activityMessageApply",
            component: ActivityMessageApply
          },
          {
            path: "activityCompanyList",
            component: ActivityCompanyList
          },
          {
            path: "activityApplyList",
            component: ActivityApplyList
          },
          {
            path: "newsList",
            component: NewsList
          },
          {
            path: "newsInfo/:method",
            component: NewsInfo
          }
        ]
      },
      {
        path: "competitionManage",
        component: CompetitionManage,
        children: [
          {
            path: "",
            redirect: "contestApplyList"
          },
          {
            path: "contestApplyList",
            component: ContestApplyList
          },
          {
            path: "contestNoticeList",
            component: ContestNoticeList
          },
          {
            path: "contestNoticeInfo/:method",
            component: ContestNoticeInfo
          },
          {
            path: "contestActivityList",
            component: ContestActivityList
          },
          {
            path: "contestActivityInfo/:method",
            component: ContestActivityInfo
          },
          {
            path: "contestDemList",
            component: ContestDemList
          },
          {
            path: "contestDemInfo/:method",
            component: ContestDemInfo
          },
          {
            path: "contestSolutionList",
            component: ContestSolutionList
          },
          {
            path: "contestSolutionInfo/:method",
            component: ContestSolutionInfo
          },
          {
            path: "contestServiceList",
            component: ContestServiceList
          }
        ]
      },
      {
        path: "userManage",
        component: UserManage,
        children: [
          {
            path: "",
            redirect: "userContentlist"
          },
          {
            path: "userContentlist",
            component: UserContentlist
          },
          {
            path: "userContentInfo/:type",
            component: UserContentInfo
          },
          {
            path: "userComCerInfo",
            component: UserComCerInfo
          },
          {
            path: "userPerCerInfo",
            component: UserPerCerInfo
          },
          {
            path: "userCertifiedist",
            component: UserCertifiedist
          }
        ]
      },
      {
        path: "systemManage",
        component: SystemManage,
        children: [
          {
            path: "",
            redirect: "notificationList"
          },

          {
            path: "notificationList",
            component: NotificationList
          },
          {
            path: "notificationInfo/:method",
            component: NotificationInfo
          }
        ]
      },
      {
        path: "privilegeManage",
        component: PrivilegeManage,
        children: [
          {
            path: "",
            redirect: "departmentList"
          },
          {
            path: "departmentList",
            component: DepartmentList
          },
          {
            path: "roleList",
            component: RoleList
          },
          {
            path: "roleInfo/:method",
            component: RoleInfo
          },
          {
            path: "accountList",
            component: AccountList
          },
          {
            path: "accountInfo/:method",
            component: AccountInfo
          }
        ]
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: "/404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

router.beforeEach((to, from, next) => {
  clearPending();
  next();
});

export default router;
